import React from 'react';
import { Box, Divider, Grid, Link, Stack, Typography } from '@mui/material';

import { getClientUrls, userCanAccessProjectsClient } from '@paragon/login-tools';
import { UserDropdown } from '@paragon/themes';

import materialsLogoUrl from '../../../resources/materials.png';
import pricingLogoUrl from '../../../resources/pricing.png';
import projectsLogoUrl from '../../../resources/projects.png';
import { getProblemReportContext } from '../../store/selectors/getProblemReportContext';
import { captureViewportPngOrNull } from '../../three/reactThreeFiberBindings';
import { useAppSelector } from '../hooks';
import { OpenPresetsDialogMenuItem } from './OpenPresetsDialogMenuItem';
import { CURRENT_VERSION, OpenUserSettingsMenuItem } from './OpenUserSettingsMenuItem';
import { UsageMenuItem } from './UsageMenuItem';

export function DesignClientUserDropdown() {
  const canAccessProjects = useAppSelector(userCanAccessProjectsClient);
  const urls = useAppSelector(getClientUrls);
  const reportContext = useAppSelector(getProblemReportContext);

  return (
    <UserDropdown
      hideThemeToggleButton
      sx={{ alignSelf: 'center' }}
      reportContext={reportContext}
      getReportScreenshot={captureViewportPngOrNull}
      additionalMenuItems={(closeMenu) => [
        <OpenUserSettingsMenuItem onClick={closeMenu} key="openUserSettingsMenuItem" />,
        <OpenPresetsDialogMenuItem onClick={closeMenu} key="openPresetsMenuItem" />,
        <UsageMenuItem closeMenu={closeMenu} key="usageMenuItem" />,
      ]}
    >
      <Divider />
      <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center' }}>
        {canAccessProjects && (
          <Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Box
                component="img"
                sx={{ height: 50, width: 50 }}
                alt="Paragon Projects"
                src={projectsLogoUrl}
                onClick={() => window.open(urls.projectsUrl, '_blank')}
              />
              <Typography variant="overline" sx={{ fontSize: '.6rem' }}>
                Projects
              </Typography>
            </Stack>
          </Grid>
        )}
        <Grid>
          <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Box
              component="img"
              sx={{ height: 50, width: 50 }}
              alt="Paragon Materials"
              src={materialsLogoUrl}
              onClick={() => window.open(urls.materialsUrl, '_blank')}
            />
            <Typography variant="overline" sx={{ fontSize: '.6rem' }}>
              Materials
            </Typography>
          </Stack>
        </Grid>
        <Grid>
          <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
            <Box
              component="img"
              sx={{
                height: 50,
                width: 50,
              }}
              alt="Paragon Pricing"
              src={pricingLogoUrl}
              onClick={() => window.open(urls.pricingUrl, '_blank')}
            />
            <Typography variant="overline" sx={{ fontSize: '.6rem' }}>
              Pricing
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={2} sx={{ width: 250, padding: 1 }}>
        <Grid sx={{ marginRight: 'auto' }}>
          <Typography variant="caption">Version {CURRENT_VERSION}</Typography>
        </Grid>
        <Grid>
          <Link target="_blank" underline="none" color="White" href="https://paragontruss.com/terms" variant="caption">
            Terms
          </Link>
        </Grid>
        <Grid>
          <Link
            target="_blank"
            underline="none"
            color="White"
            href="https://paragontruss.com/privacy"
            variant="caption"
          >
            Privacy Policy
          </Link>
        </Grid>
      </Grid>
    </UserDropdown>
  );
}
